import { useMutation } from "react-query";
import useApi from "./useApiRequest";

export const UpdateUser = ()  => {
  const api = useApi();

  const mutate = async (params) => {
    const data  = await api.put(`/usuarios/${params.id}`, params.body, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    updateUserMutation: mutation.mutate,
  };
}